import edap from '@homeaway/edap-wrapper';

// EDAP EVENTS
export const ADD_GUEST_PRESENTED = 'add_guest.presented';
export const ADD_GUEST_SELECTED = 'add_guest.selected';
export const ADD_GUEST_SUBMITTED = 'add_guest.submitted';
export const ADD_GUEST_SUCCEEDED = 'add_guest.succeeded';
export const ADD_GUEST_EMAIL_INPUTTED = 'add_guest_email.inputted';
export const ALERT_BANNER_LINK_SELECTED = 'alert_banner_link.selected';
export const APP_DOWNLOAD_SELECTED = 'app_download.selected';
export const GENERIC_MODAL = 'generic.modal';
export const INBOX_PRESENTED = 'inbox.presented';
export const INBOX_MESSAGE_SELECTED = 'inbox_message.selected';
export const MANAGE_GUESTS_SELECTED = 'manage_guests.selected';
export const REMOVE_GUEST_SELECTED = 'remove_guest.selected';
export const TRIP_COLLECTION_PRESENTED = 'trip_collection.presented';
export const TRIP_HEADER_IMAGE_SELECTED = 'trip_header_image.selected';
export const TRIP_MESSAGE_SET_SELECTED = 'trip_message_set.selected';
export const TRIP_PAYMENT_SET_SELECTED = 'trip_payment_set.selected';
export const TRIP_SELECTED = 'trip.selected';

// ACTION LOCATIONS
export const BOOKING_CONFIRMATION_EMAIL = 'booking_confirmation_email';
export const INBOX = 'inbox';
export const MODIFY_BOOKING = 'modify_booking';

// ACTION TYPE
export const MODIFY_REQUEST = 'modify_request';

// UTM CONTENT VALUES
export const GOG_INVITE_BC_EMAIL = 'gog_invite_bc_email';

export const triggerEdap = (name, data) => {
    edap().push({
        name,
        data,
    });
};

export const addGuestEmailInputted = ({
    actionLocation,
    reservationUUID,
    reservationDeparture,
    reservationArrival,
    adults,
    children,
}) => {
    triggerEdap(ADD_GUEST_EMAIL_INPUTTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
        date_end: reservationDeparture,
        date_start: reservationArrival,
        adult_count: `${adults}`,
        child_count: `${children}`,
    });
};

export const addGuestPresented = ({
    actionLocation,
    reservationUUID,
    reservationDeparture,
    reservationArrival,
}) => {
    triggerEdap(ADD_GUEST_PRESENTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
        date_end: reservationDeparture,
        date_start: reservationArrival,
    });
};

export const addGuestSelected = ({
    actionLocation,
    reservationUUID,
    reservationArrival,
    reservationDeparture,
    adults,
    children,
}) => {
    triggerEdap(ADD_GUEST_SELECTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
        date_start: reservationArrival,
        date_end: reservationDeparture,
        adult_count: `${adults}`,
        child_count: `${children}`,
    });
};

export const addGuestSubmitted = ({
    actionLocation,
    reservationUUID,
    reservationArrival,
    reservationDeparture,
    adults,
    children,
}) => {
    triggerEdap(ADD_GUEST_SUBMITTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
        date_start: reservationArrival,
        date_end: reservationDeparture,
        adult_count: `${adults}`,
        child_count: `${children}`,
    });
};

export const addGuestSucceeded = ({
    actionLocation,
    reservationUUID,
    reservationArrival,
    reservationDeparture,
    adults,
    children,
}) => {
    triggerEdap(ADD_GUEST_SUCCEEDED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
        date_start: reservationArrival,
        date_end: reservationDeparture,
        adult_count: `${adults}`,
        child_count: `${children}`,
    });
};

export const alertBannerLinkSelected = ({
    actionLocation,
    reservationUUID,
    alertType,
}) => {
    triggerEdap(ALERT_BANNER_LINK_SELECTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
        alert_type: alertType,
    });
};

export const manageGuestsSelected = ({
    actionLocation,
    reservationUUID,
    reservationArrival,
    reservationDeparture,
    adults,
    children,
}) => {
    triggerEdap(MANAGE_GUESTS_SELECTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
        date_start: reservationArrival,
        date_end: reservationDeparture,
        adult_count: `${adults}`,
        child_count: `${children}`,
    });
};

export const removeGuestSelected = ({
    actionLocation,
    reservationUUID,
    reservationArrival,
    reservationDeparture,
    adults,
    children,
}) => {
    triggerEdap(REMOVE_GUEST_SELECTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
        date_start: reservationArrival,
        date_end: reservationDeparture,
        adult_count: `${adults}`,
        child_count: `${children}`,
    });
};

export const tripHeaderImageSelected = ({
    actionLocation,
    reservationUUID,
    endDate,
    startDate,
}) => {
    triggerEdap(TRIP_HEADER_IMAGE_SELECTED, {
        action_location: `trip_${actionLocation}`,
        reservation_id: reservationUUID,
        date_end: endDate,
        date_start: startDate,
    });
};

export const tripMessageSetSelected = ({
    actionLocation,
    experienceType,
    reservationArrival,
    reservationDeparture,
    reservationUuid,
}) => {
    const data = {
        action_location: actionLocation,
        reservation_id: reservationUuid || '-1',
    };
    if (experienceType) {
        data.experience_type = experienceType;
    }
    if (reservationArrival) {
        data.date_start = reservationArrival;
    }
    if (reservationDeparture) {
        data.date_end = reservationDeparture;
    }

    triggerEdap(TRIP_MESSAGE_SET_SELECTED, data);
};

export const tripPaymentSetSelected = ({
    actionLocation,
    reservationArrival,
    reservationDeparture,
    reservationUuid,
}) => {
    triggerEdap(TRIP_PAYMENT_SET_SELECTED, {
        action_location: actionLocation,
        date_start: reservationArrival,
        date_end: reservationDeparture,
        reservation_id: reservationUuid,
    });
};
